import { useMutation } from '@tanstack/react-query'

import useResize from '../../../hooks/useResize'
import { TAGS } from '../../../services/Tags'
import { LIMIT_OF_CHARACTERS, VIEWPORT_LG } from '../../../utils/constants'
import { ErrorMessage } from '@hookform/error-message'
import Button from '../../../components/Button'
import { useForm } from 'react-hook-form'
import {
  createFastOfferHutritNext,
} from '../../../services/OfferManagement'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
import Loader from '../../../components/Loader'
import confetti from 'canvas-confetti'
import { useTranslation } from 'react-i18next'
import Divider from '../../../components/Divider'
import Toast from '../../../components/Toast/Toast'

const initialValues = {
  companyName: 'LOLO',
  reprentativeName: '',
  email: '',
  langOffer: [
    {
      idLang: '2',
      lang_level_id: '3',
    },
  ],
  skillsOffer: [
    {
      idSkill: 1,
    },
    {
      idSkill: 9,
    },
    {
      idSkill: 2,
    },
  ],
  modalitys: [3],
  name: 'LOLO',
  description: '',
  activities: 'asdasdasdas',
  IdCategorie: 12,
}

const CreatFastJobOffer = () => {
  const { t } = useTranslation()
  const MySwal = withReactContent(Swal)

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    watch,
  } = useForm({ defaultValues: initialValues })

  const description = watch('description')
  const data = watch()
  const viewportSize = useResize()
  const isMobile = viewportSize[0] <= VIEWPORT_LG

  const {
    mutate: createFastOfferHutritNextMutate,
    isLoading: isLoadingCreateOfferHutritNext,
  } = useMutation([TAGS.create_offer_hutrit_next], createFastOfferHutritNext, {
    onSuccess: ({ response }) => {
      if (response?.status === 200) {
        confetti()
        Toast({ title: 'Oferta creada correctamente' })
        reset()
      }
      if (response?.status !== 200) {
        MySwal.fire({
          title: <strong>{t('error_in_the_system')}</strong>,
          icon: 'error',
          confirmButtonColor: 'Red',
        })
        return
      }
    },
  })

  const customData = {
    ...data,
  }

  const onSubmit = () => {
    createFastOfferHutritNextMutate(customData)
  }

  return (
    <form
      className="border rounded p-4 bg-white"
      style={{
        marginTop: isMobile ? '' : '10px',
        width: isMobile ? '100%' : '543px',
      }}
      onSubmit={handleSubmit(onSubmit)}
    >
      <label className="text-on-bg-secondary">Sobre ti</label>

      <div className="w-100">
        <label className="d-flex align-items-center gap-2 form-label text-on-bg-primary">
          Nombre
        </label>
        <input
          className="form-control"
          type="text"
          placeholder="Escribe tu nombre"
          {...register('reprentativeName', {
            required: t('this_field_is_required'),
          })}
        />
        <ErrorMessage
          errors={errors}
          name="reprentativeName"
          render={({ message }) => (
            <span className="text-danger font-small">{message}</span>
          )}
        />
      </div>
      <div className="w-100 mt-2 mb-2">
        <label className="d-flex align-items-center gap-2 form-label text-on-bg-primary">
          Correo electrónico
        </label>

        <input
          className="form-control"
          type="email"
          placeholder="Escribe tu correo"
          {...register('email', {
            required: t('this_field_is_required'),
          })}
        />
        <ErrorMessage
          errors={errors}
          name="email"
          render={({ message }) => (
            <span className="text-danger font-small">{message}</span>
          )}
        />
      </div>
      <div className="w-100">
        <label className="d-flex align-items-center gap-2 form-label text-on-bg-primary">
          Número de teléfono
        </label>
        <input
          className="form-control"
          type="text"
          placeholder="Número de teléfono"
          {...register('phone', {
            required: t('this_field_is_required'),
          })}
        />
        <ErrorMessage
          errors={errors}
          name="phone"
          render={({ message }) => (
            <span className="text-danger font-small">{message}</span>
          )}
        />
      </div>

      <Divider
        className="bg-on-bg-primary w-100 mt-4 mb-4"
        style={{
          opacity: 0.1,
        }}
      />

      <label className="text-on-bg-secondary">
        Sobre el talento que necesitas
      </label>
      <div style={{ marginTop: isMobile ? '7.5px' : '15px' }}>
        <label className="form-label text-on-bg-primary">
          Explícanos sobre lo que necesitas
        </label>
        <textarea
          {...register('description', {
            required: t('this_field_is_required'),
            validate: (value) => {
              const urlRegex = /(http(s)?:\/\/[^\s]+)/gi
              if (urlRegex.test(value)) {
                return t('no_external_links_allowed_in_this_field')
              }

              if (description?.length >= LIMIT_OF_CHARACTERS) {
                return `${description?.length}/${LIMIT_OF_CHARACTERS}`
              }
            },
          })}
          rows="3"
          className="form-control"
          id="sector"
        ></textarea>
        <ErrorMessage
          errors={errors}
          name="description"
          render={({ message }) => (
            <span className="text-danger font-small">{message}</span>
          )}
        />
      </div>
      <Button
        disabled={isLoadingCreateOfferHutritNext}
        className="btn-bg-CTA-primary w-100 mt-3"
        type="submit"
      >
        {isLoadingCreateOfferHutritNext ? <Loader /> : 'Enviar formulario'}
      </Button>
    </form>
  )
}

export default CreatFastJobOffer
